import { constantsData, formFieldNamesData } from "@/data";
import { InputTypeEnum } from "@/enums";

const { password } = constantsData.forms.users.password;
const { password: passwordFieldName } = formFieldNamesData;

export const userPasswordFormData = [
    {
        description: password.description,
        label: password.label,
        name: passwordFieldName,
        type: InputTypeEnum.PASSWORD,
    },
];
